
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateChatDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
})
;
}
      